import browser from './app';
import domUtils from './domUtils';
import dateUtils from './dateUtils';
import validateUtils from './validateUtils';
import formatUtils from './formatUtils';
import localStorageUtils from './localStorageUtils.js';
import businessCustomerUtils from './businessCustomerUtils';
import {
  EMAIL,
  ZIPCODE,
  PASSWORD,
  WEBSITE,
  PHONENUMBER
} from './regExp'

const CreateUtils = (Vue) => {
  Vue.prototype.$browser = browser
  Vue.prototype.$utils = {
    PAGESIZE: [10, 20, 30, 50],
    formatAmount: browser.formatAmount,
    RegExps: {
      EMAIL,
      ZIPCODE,
      PASSWORD,
      WEBSITE,
      PHONENUMBER
    },
    refresh(path) {
      if (path) {
        return window.location.href = path
      }
      window.location.href = window.location.href
    },
    toHome(params) {
      this.toRouter('/', params);
    },
    getUrlByRouter(toRouter = '', params) {
      var search = '';
      for (var i in params) {
        search += `${search?'&':'?'}${i}=${params[i]}`
      }
      return window.location.origin + toRouter + search;
    },
    toRouter(toRouter = '', params) {
      this.refresh(this.getUrlByRouter.apply(null, arguments));
    },
    openRouterInNewWindow() {
      window.open(this.getUrlByRouter.apply(null, arguments), '_blak')
    },
    isMobile() {
      return browser.mobile
    },
    isApp() {
      try {
        return /^\/app/i.test(window.location.pathname) ? true : fasle
      } catch (e) {
        return false
      }
    },
    isBusiness() {
      try {
        return /^\/business/i.test(window.location.pathname) ? true : fasle
      } catch (e) {
        return false
      }
    },
    getAppLang() {
      let lang = this.getCookie('x-dm-lang');
      if (!lang) {
        lang = window.navigator.language
      }
      return lang || null;
    },
    getTimeZoneStr() {
      var timeZone = (new Date()).getTimezoneOffset();
      var timeZoneHH = (Math.abs(Math.floor(timeZone / 60)) + 100 + '').substr(1);
      var timeZoneMM = ((Math.abs(timeZone) % 60) + 100 + '').substr(1);
      return 'GMT' + (timeZone > 0 ? '-' : '+') + timeZoneHH + ':' + timeZoneMM;
    },
    deleteInvalidePhoneNumber(phone = '') {
      let arr = phone.split('')
      let newString = ''
      for (var i = 0, len = arr.length; i < len; i++) {
        if (PHONENUMBER.test(arr[i])) {
          newString += arr[i];
        }
      }
      return newString
    },
    autoFillHttp(website = '') {
      if (!website || WEBSITE.test(website)) return website;
      return `http://${website}`;
    },
    arrayBufferToBase64(buffer) {
      var binary = '';
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return `data:image/jpg;base64,${window.btoa(binary)}`
    },
    queryParams(key) {
      let url = window.location.href;
      var matchArr = url.match(new RegExp(`[?&]${key}=([^&]*)`));
      var match = matchArr && matchArr[1];
      return match ? decodeURIComponent(match) : null
    },
    addParams(key, value) {
      let href = window.location.href;
      href += (href.indexOf('?') > -1 ? '&' : '?') + `${key}=${value}`
      return href
    },
    pickByKey(iterator, key, tarVal) {
      var res = null
      for (var i = 0, len = iterator.length; i < len; i++) {
        if (iterator[i][key] == tarVal) {
          res = iterator[i];
          break;
        }
      }
      return res
    },
    extend(source = {}, ...extendObj) {
      return Object.assign(source, ...extendObj)
    },
    throttle(func, wait = 300) {
      let last = 0,
        context,
        result;
      return () => {
        let now = Date.now();
        context = this;
        if (now - last > wait) {
          last = now
          result = func.apply(context, arguments)
        }
        return result
      }
    },
    debounce(func, wait = 300) {
      let timeout = null,
        context, args;
      return () => {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        context = this;
        args = arguments;
        timeout = setTimeout(() => {
          func.apply(context, args)
        }, wait);
      }
    },
    ...domUtils,
    ...dateUtils,
    ...formatUtils,
    ...validateUtils,
    ...localStorageUtils,
    ...businessCustomerUtils
  }
  window.utils = Vue.prototype.$utils;
}


export default CreateUtils



// WEBPACK FOOTER //
// ./src/utils/index.js